
export class TypeExpertise {
	public id: number;
	public name: string;

  	constructor(
  	) {}
}
